import React from "react";
import Me3 from "../../assets/me3.png";
import "./header.css";
function Header({ isBlur }) {
  return (
    <div className={`header ${isBlur}`}>
      <div className="text">
        <h1>Hello!</h1>
        <h2>I am Banks Mustapha Olamiji</h2>
        <h3>
          I am a front end web developer from Lagos, Nigeria. With a keen eye
          for detail and a creative mindset, I approach each project with
          enthusiasm and strive to deliver my best work. Welcome to my web
          portfolio, check me out!
        </h3>
      </div>
      <div className="img">
        <img src={Me3} alt="Me" srcset="" />
      </div>
    </div>
  );
}

export default Header;
